module.exports = __webpack_public_path__ + "img/629-a1db86.png";